import { Component, inject, input, ChangeDetectionStrategy } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { TranslocoService } from '@jsverse/transloco';

@Component({
	selector: 'ara-soon-badge',
	imports: [MatTooltip],
	templateUrl: './ara-soon-badge.component.html',
	changeDetection: ChangeDetectionStrategy.Eager,
	styleUrl: './ara-soon-badge.component.scss',
})
export class AraSoonBadgeComponent {
	readonly height = input<number>(20);
	protected readonly transloco = inject(TranslocoService);
}
